import { useState } from 'react';

// Hook to manage loading state
export const useLoading = () => {
    const [skeletonLoading, setSkeletonLoading] = useState<boolean>(true);

    // Function to start loading
    const startSkeletonLoading = () => setSkeletonLoading(true);

    // Function to stop loading
    const stopSkeletonLoading = () => setSkeletonLoading(false);

    return { skeletonLoading, startSkeletonLoading, stopSkeletonLoading };
};
